import React from "react";
import ClientTemplatesTabs from "./ProfileComponent";

const ClientComponent = ({
  onGetClientProfile,
  clientProfile,

  onGetPartnerDetail,
  partnerDetail,

  onGetFamilyMemberDetail,
  familyMemberDetail,

  onAddClientMember,
  addClientMember,

  onaddClientProfile,

  onUpdateClientEmail,

  onClientProfileSaveAddress,

  onUpdateClientPhone,

  onUpdateClientPassport,
  updateClientPassport,

  onUpdateClientMedical,

  onUpdateClientProfileMember,

  onGetEmployerInformation,
  employerInformationRes,
  onAddemployerInformation,
  onUpdateEmployerInformation,

  onaddJobHistory,

  onAddQualificaion,

  onGetJobHistoryData,
  getJobHistoryRes,

  onPutJobHistoryData,

  onGetQualificationData,
  getQualificationRes,

  onPutQualificationData,

  getAllCountriesRes,
  onGetAllCountriesData,

  onGetPartnerJobData,
  getPartnerJobRes,

  onGetPartnerQualificationData,
  getPartnerQualificationRes,
  onGetVisaTypes,
  onUpdatePermissions,
  onForgotPassword,
  onGetJobALLStatuses,
  jobStatusSuccess,
}) => (
  <div className="container">
    <ClientTemplatesTabs
      onGetClientProfile={onGetClientProfile}
      clientProfile={clientProfile}
      onGetPartnerDetail={onGetPartnerDetail}
      partnerDetail={partnerDetail}
      onGetFamilyMemberDetail={onGetFamilyMemberDetail}
      familyMemberDetail={familyMemberDetail}
      onaddClientProfile={onaddClientProfile}
      onUpdateClientEmail={onUpdateClientEmail}
      onClientProfileSaveAddress={onClientProfileSaveAddress}
      onUpdateClientPhone={onUpdateClientPhone}
      onUpdateClientPassport={onUpdateClientPassport}
      updateClientPassport={updateClientPassport}
      onUpdateClientMedical={onUpdateClientMedical}
      onUpdateClientProfileMember={onUpdateClientProfileMember}
      onGetEmployerInformation={onGetEmployerInformation}
      employerInformationRes={employerInformationRes}
      onAddemployerInformation={onAddemployerInformation}
      onUpdateEmployerInformation={onUpdateEmployerInformation}
      onaddJobHistory={onaddJobHistory}
      onAddQualificaion={onAddQualificaion}
      onGetJobHistoryData={onGetJobHistoryData}
      getJobHistoryRes={getJobHistoryRes}
      onPutJobHistoryData={onPutJobHistoryData}
      onGetQualificationData={onGetQualificationData}
      getQualificationRes={getQualificationRes}
      onPutQualificationData={onPutQualificationData}
      getAllCountriesRes={getAllCountriesRes}
      onGetAllCountriesData={onGetAllCountriesData}
      onGetPartnerJobData={onGetPartnerJobData}
      getPartnerJobRes={getPartnerJobRes}
      onGetPartnerQualificationData={onGetPartnerQualificationData}
      getPartnerQualificationRes={getPartnerQualificationRes}
      onAddClientMember={onAddClientMember}
      addClientMember={addClientMember}
      onGetVisaTypes={onGetVisaTypes}
      onUpdatePermissions={onUpdatePermissions}
      onForgotPassword={onForgotPassword}
      onGetJobALLStatuses={onGetJobALLStatuses}
      jobStatusSuccess={jobStatusSuccess}
    />
  </div>
);

export default ClientComponent;
